import { PlatformSection } from '@/common/components';
import { useNewTranslations } from '@/common/translations';

import { usePrematchData } from '../../hooks';
import { OtherMatchInformation } from '../../components';

export default function OtherInfosSection() {
  const { statistics } = usePrematchData();
  const translate = useNewTranslations();

  const venue = statistics?.otherInfo?.venue;
  const referee = statistics?.otherInfo?.referee;

  if (!statistics?.otherInfo || (!venue && !referee)) {
    return null;
  }

  const stadium = venue ? { name: venue.name, capacity: venue.capacity } : undefined;
  const mappedReferee = referee ? { name: referee.name, flagUrl: referee.flag } : undefined;

  // TODO: https://jira.kindredgroup.com/browse/PMAR-1326
  // pass weather data to OtherMatchInformation once we start getting it from backend

  return (
    <PlatformSection name={translate('PreMatchStats.OtherInfo')}>
      <OtherMatchInformation stadium={stadium} referee={mappedReferee} />
    </PlatformSection>
  );
}
